import React, { useRef } from 'react';
import copy from 'clipboard-copy';
import cn from 'classnames';
import { Button } from 'react-bootstrap';
import { UiIcon } from '../../../common/icons/ui-icon';
import { Files as IconFiles } from 'react-bootstrap-icons'

export type CopyButtonProps = {
  className?: string;
  text: string;
};

export const CopyTooltipEvent = 'CopyTooltipEvent';

const CopyButton = ({ className, text }: CopyButtonProps) => {
  const copyButtonRef = useRef<HTMLButtonElement>(null);
  return (
    <Button
      ref={copyButtonRef}
      className={cn('btn-icon', className)}
      data-for="copy"
      data-tip="Copied"
      data-place="left"
      data-effect="solid"
      data-event={CopyTooltipEvent}
      data-scroll-hide
      size='sm'
      variant='light'
      title={''}
      onClick={() => {
        copy(text);
        if (copyButtonRef.current) {
          const event = new Event(CopyTooltipEvent);
          (copyButtonRef.current as Element).dispatchEvent(event);
        }
      }}
    >
      <UiIcon icon={IconFiles} />
    </Button>
  );
};

export default CopyButton;
